// extracted by mini-css-extract-plugin
module.exports = {"Icon":"ShowCodeBtn_Icon__dZ2oF","ViewCodeText":"ShowCodeBtn_ViewCodeText__3Su2T","ViewCodeContainer":"ShowCodeBtn_ViewCodeContainer__2fIg6"};